import React, { PureComponent } from 'react';
// import PropTypes from 'prop-types';
import { Element, scroller } from 'react-scroll';
import { FastField } from 'formik';
import get from 'lodash/get';
import findKey from 'lodash/findKey';
import isNull from 'lodash/isNull';
import toPx from 'to-px';
import { compose } from 'redux';
import { StickyContainer } from 'react-sticky';
import { reach } from 'yup';
import bowser from 'bowser';
import { withTheme } from 'styled-components'

import Button from '../../components/Button';
import Box from '../../components/Box';
import { Offset } from '../../components/Survey/Counter';

import getRandomID from '../../components/utils/getRandomID';
import withLabel from '../../components/Survey/withLabel';
import withTimer from '../../components/Survey/withTimerButton';
import getModule from '../getModule';

class TheForm extends PureComponent {
  constructor(props) {
    super(props);

    this.modules = props.modules.map(({ module, label }) => {
      const Module = getModule(module);
      return Module && label ? compose(withTimer, withLabel)(Module) : Module;
    });
    this.randomID = getRandomID(6);
    this.namePttrn = /\d+-\d+/;
    if (typeof window !== 'undefined') {
      const browser = bowser.getParser(window.navigator.userAgent);
      this.isDesktop = browser.getPlatform().type === 'desktop';
    }
  }

  componentDidUpdate(prevProps) {
    const { isSubmitting, touched, errors, values, onSetAnswer } = this.props;
    if (isSubmitting !== prevProps.isSubmitting) {
      const firstError = findKey(errors, Boolean);
      if (touched[firstError]) {
        const [name] = this.namePttrn.exec(firstError);
        this.scrollToName(name);
      }
    }
    if (values !== prevProps.values) {
      onSetAnswer(values)
    }
  }

  scrollToName = (name) => scroller.scrollTo(name, {
    duration: 1000,
    smooth: true,
    offset: -toPx(this.props.theme.headerHeight) - 10,
  })

  testRequired = (name, values) => {
    const { validationSchema } = this.props;
    let required;
    let noSchema;

    try {
      reach(validationSchema, name)
    } catch (e) {
      noSchema = true;
    }

    if (!noSchema) {
      try {
        validationSchema.validateSyncAt(name, validationSchema.cast(Object.assign({}, values, { [name]: undefined })));
      } catch(e) {
        console.log(e);
        required = true;
      }
    }
    return required
  }

  render() {
    const {
      values,
      touched,
      modules,
      pageIndex,
      isSubmitting,
      hideButton,
      isLastPage,
      offset,
      gap,
      handleSubmit,
      isAlter,
      viewMode,
      hasProgess,
      preferHintRequired,
    } = this.props;
    return (
      <form onSubmit={handleSubmit}>
        <Offset name={this.randomID} offset={offset} />
        {modules.map(({ module, schema, lock, ...d }, key) => {
          const Module = this.modules[key];
          if (!Module) return null;
          const name = `${pageIndex}-${key}`;
          return (
            <StickyContainer key={key}>
              <Box position="relative" px={['1em', null, '3em']} my={gap}>
                {d.label && (
                  <Box
                    position="absolute"
                    left="0"
                    top="0.5em"
                    bottom="0"
                    width="0.25em"
                    bg="primary"
                  />
                )}
                <Element name={name}>
                  <FastField name={name}>
                    {({ field }) => (
                      <Module
                        {...d}
                        {...field}
                        values={values}
                        randomID={this.randomID}
                        required={get(schema, 'required') || this.testRequired(name, values)}
                        touched={touched[name]}
                        sort={module === 'sort'}
                        readOnly={viewMode}
                        hasDnD={this.isDesktop}
                        snap={viewMode ? false : (isNull(d.snap) ? true : d.snap)}
                        hasProgess={hasProgess}
                        preferHintRequired={preferHintRequired}
                      />
                    )}
                  </FastField>
                </Element>
              </Box>
            </StickyContainer>
          );
        })}
        {!viewMode && (isAlter || !hideButton) && (
          <Box mt={gap} mb="2rem" align="center">
            <Button
              type="submit"
              disabled={isSubmitting}
            >
              {isLastPage ? '送出' : '下一頁'}
            </Button>
          </Box>
        )}
      </form>
    );
  }
}

export default withTheme(TheForm);
